const PROFILE_TABS = ["overview", "bundles", "memberships", "purchases", "activity", "settings"] as const;

/** The tab the profile opens at: the one asked for when the profile has it
 * (the memberships tab shows only with a membership), else Overview. */
export function initialTabOf(asked: string | undefined, hasMemberships: boolean): string {
  const tab = (PROFILE_TABS as readonly string[]).includes(asked ?? "") ? (asked as string) : "overview";
  return tab === "memberships" && !hasMemberships ? "overview" : tab;
}
